import * as types from './constants/index'

const initialState = {
    profile: null,
    errors: null,
    singleError: null,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case types.USER_REGISTERED:
            return {
                ...state,
                profile: action?.payload
            };

        case types.USER_LOGGED_IN:
            return {
                ...state,
                profile: action?.payload
            };

        case types.LOGOUT:
            return {
                ...state,
                profile: null
            }

        case types.AUTH_ERROR:
            return {
                ...state,
                errors: action.payload
            }

        case types.AUTH_ERROR_SINGLE:
            return {
                ...state,
                singleError: action.payload
            }

        case types.CLR_AUTH_MSGS:
            return {
                ...state,
                errors: null,
                singleError: null,
            }
        default:
            return state;
    }
}